import { CRUD_PERMISSIONS, IRole, Role } from "@nova/common-interfaces";
import { USER_ROLES } from "@rfm/shared-interfaces";
import { BehaviorSubject } from "rxjs";

export class Claims {
  // #region Properties (2)

  private _claims = new BehaviorSubject<Role[]>([]);

  claims$ = this._claims.asObservable();

  // #endregion Properties (2)

  // #region Public Methods (5)

  public checkClaim(
    claim: USER_ROLES | string,
    crud: CRUD_PERMISSIONS
  ): boolean {
    const role = this._claims.value.find(
      (x) => x.role_name.toLowerCase() == claim.toLowerCase()
    );

    if (!role || role == undefined) {
      return false;
    }

    if (CRUD_PERMISSIONS.CREATE === (crud & CRUD_PERMISSIONS.CREATE)) {
      if (CRUD_PERMISSIONS.CREATE !== (role.crud & CRUD_PERMISSIONS.CREATE)) {
        return false;
      }
    }

    if (CRUD_PERMISSIONS.READ === (crud & CRUD_PERMISSIONS.READ)) {
      if (CRUD_PERMISSIONS.READ !== (role.crud & CRUD_PERMISSIONS.READ)) {
        return false;
      }
    }

    if (CRUD_PERMISSIONS.UPDATE === (crud & CRUD_PERMISSIONS.UPDATE)) {
      if (CRUD_PERMISSIONS.UPDATE !== (role.crud & CRUD_PERMISSIONS.UPDATE)) {
        return false;
      }
    }

    if (CRUD_PERMISSIONS.DELETE === (crud & CRUD_PERMISSIONS.DELETE)) {
      if (CRUD_PERMISSIONS.DELETE !== (role.crud & CRUD_PERMISSIONS.DELETE)) {
        return false;
      }
    }
    return true;
  }

  public checkClaimNameOnly(claim: USER_ROLES | string): boolean {
    const role = this._claims.value.find(
      (x) => x.role_name.toLowerCase() == claim.toLowerCase()
    );
    if (role === undefined) {
      return false;
    }
    return true;
  }

  public reset() {
    this._claims.next([]);
  }

  public setByRole(role: IRole) {
    const roleClass = Role.createRole(role);

    let newClaims = this._claims.value;

    if (roleClass.canRead()) {
      if (!this.checkClaimNameOnly(role.role_name)) {
        newClaims.push({ ...role } as Role);
      }
    } else {
      if (this.checkClaimNameOnly(role.role_name)) {
        const index = newClaims.findIndex(
          (x) => x.role_name.toLowerCase() == role.role_name.toLowerCase()
        );
        if (index > -1) {
          newClaims = newClaims.splice(index, 1);
        }
        newClaims.push({ ...role } as Role);
      }
    }
    this._claims.next(newClaims);
  }

  /**
   * Set a claim using CRUD logic
   * @param { UserRole } claim
   * @param { boolean} c
   * @param { boolean} r
   * @param { boolean} u
   * @param { boolean} d
   */
  public setClaim(
    claim: USER_ROLES,
    c: boolean,
    r: boolean,
    u: boolean,
    d: boolean
  ): void {
    let newClaims = this._claims.value;

    let permission = CRUD_PERMISSIONS.UNKNOWN;

    if (c) {
      permission |= CRUD_PERMISSIONS.CREATE;
    }

    if (r) {
      permission |= CRUD_PERMISSIONS.READ;
    }

    if (u) {
      permission |= CRUD_PERMISSIONS.UPDATE;
    }

    if (d) {
      permission |= CRUD_PERMISSIONS.DELETE;
    }

    if (!this.checkClaimNameOnly(claim)) {
      newClaims.push({
        role_name: claim.toLowerCase(),
        crud: permission,
      } as Role);
    } else {
      if (this.checkClaimNameOnly(claim)) {
        const index = newClaims.findIndex(
          (x) => x.role_name.toLowerCase() == claim.toLowerCase()
        );
        if (index > -1) {
          newClaims = newClaims.splice(index, 1);
        }
        newClaims.push({
          role_name: claim.toLowerCase(),
          crud: permission,
        } as Role);
      }
    }
    this._claims.next(newClaims);
  }

  // #endregion Public Methods (5)
}